import React, { useEffect, useMemo, useRef, useState } from 'react';
import moment from 'moment';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { exportBankReconExcel } from '../../utils/export-recon-excel';
import { tryToFetchMonthlyBank } from '../../store/brokers/partners/transactions/transactionsSlice';
import BankReconTable from './BankReconTable';
import Button from '../../shared/button';
import Modal from '../../shared/modal';
import DateMonth from './DateMonth';


const bankData = [
    { name: 'Adyen', value: 'adyen', date: 'A', text: 'text-white', bg: 'bg-[#414651]', variable: 'adyen' },
    { name: 'AMEX', value: 'amex', date: 'B', text: '', bg: 'bg-[#E9EAEB]', variable: 'amex' },
]

const bankTabs = [
    { name: 'Transactions', value: 'transactions' },
    { name: 'Variance', value: 'variance' },
];

const BankReconModal = ({
    open,
    onClose,
    monthSelected
}: {
    open: boolean;
    monthSelected?: any;
    onClose: () => void;
}) => {
    const dispatch = useAppDispatch();
    const [positiveVariance] = useState<any>();
    const [search, setSearch] = useState<string>('');
    const [reconData, setReconData] = useState<any>();
    const [month, setMonth] = useState<any>();
    const [activeTab, setActiveTab] = useState(bankTabs[0]);
    const loadingRows = useAppSelector(state => state?.transactions?.monthlyAreLoading)
    const data = useAppSelector(state => state?.transactions)

    const formattedMonth: string | undefined = useMemo(() => {
        return month ? moment(month).startOf('month').format('MM/YYYY') : undefined;
    }, [month]);

    const lastKeyRef = useRef<string | undefined>(undefined);
    const inFlightRef = useRef(false);

    useEffect(() => {
        const key = formattedMonth ?? 'NO_MONTH';

        if (lastKeyRef.current === key || inFlightRef.current) return;

        inFlightRef.current = true;
        (async () => {
            try {
                const dataForm: any = { layer: 1 };
                if (formattedMonth || monthSelected) dataForm.filterMonth = formattedMonth || moment(monthSelected).format('MM/YYYY');
                await dispatch(tryToFetchMonthlyBank(dataForm)).unwrap();
                lastKeyRef.current = key;
            } catch (e) {
                console.error(e);
            } finally {
                inFlightRef.current = false;
            }
        })();
    }, [dispatch, formattedMonth]);

    useEffect(() => {
        setReconData(data?.bankMonthly)
    }, [data?.bankMonthly])

    useEffect(() => {
        if (!monthSelected) return;
        if (!month || !moment(month).isSame(monthSelected, 'month')) {
            setMonth(monthSelected);
        }
    }, [monthSelected]);

    const onChangeMonthFilter = (value: any) => {
        setMonth(value)
    }

    return (
        <Modal
            open={open}
            // title={''}
            onClose={onClose}
            contentContainerStyle='!rounded-xl min-w-[95%] md:min-w-[90%] lg:min-w-[80%]'>
            <div className='p-2 max-w-[95vw] md:min-w-[70%] lg:min-w-[60%] min-h-[500px]'>
                <div className='flex flex-col md:flex-row md:items-center'>
                    <p className='font-bold text-lg md:mr-3 dark:text-primary-dark'>Monthly Bank Reconciliation</p>
                    <DateMonth
                        containerStyle={'w-auto max-w-[200px]'}
                        value={month}
                        onChange={onChangeMonthFilter}
                        fromYear={2015}
                        toYear={2030}
                    />
                </div>
                <div className='border border-1 my-4 p-3 rounded-md'>
                    <p className='mb-4 dark:text-primary-dark'>{reconData?.length > 0 ? reconData?.length - 1 : 0} days data has been processed and<span className={(reconData?.length > 1) ? positiveVariance ? 'text-[#10B981]' : 'text-[#EF4444]' : ''}>{(reconData?.length > 1) ? positiveVariance ? ' zero variances' : ' there are variances that require attention.' : ' zero variances'}</span></p>
                    <div className='flex flex-col md:flex-row md:items-center gap-3'>
                        <input
                            value={search}
                            onChange={e => setSearch(e.target.value)}
                            placeholder={'Search…'}
                            className='border rounded px-3 py-2 w-full md:max-w-[220px] dark:bg-black dark:text-primary-dark'
                        />
                        <div className="my-5 rounded-xl md:rounded-full w-full md:w-auto bg-[#1E4380] dark:bg-black flex flex-col md:flex-row items-center px-2 py-2 md:px-1 md:py-1">
                            {bankTabs.map((item, idx) => (
                                <div
                                    key={item.name}
                                    onClick={() => setActiveTab(item)}
                                    className={`px-3 cursor-pointer w-[99%] md:w-auto m-auto text-center mb-2 md:mb-0 hover:opacity-90 ${activeTab?.name === item?.name
                                        ? 'bg-white dark:bg-bgColor-darkMode text-black dark:text-white rounded-lg md:rounded-full'
                                        : 'text-white dark:text-gray-600'
                                        } ${idx === 0 ? 'mr-2' : ''}`}
                                >
                                    <p>{item?.name}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                <div className='border border-1 my-3 p-1 grid grid-cols-1 md:grid-cols-2 gap-4 rounded-md'>
                    {bankData?.map((item: any, idx: number) => {
                        return <div key={idx} className='border border-1 my-4 p-3 rounded-md '>
                            <div className='flex flex-col md:flex-row md:justify-between items-center'>
                                <div className='flex flex-col md:flex-row items-center'>
                                    <div className={`rounded-full ${item?.bg} px-2 py-1 md:mr-2`}>
                                        <p className={`${item?.text}`}>{item?.name}</p>
                                    </div>
                                    <p className='font-bold dark:text-primary-dark'>Bank vs {item?.name} Reconciliation</p>
                                </div>
                                <div>
                                    <p className='dark:text-primary-dark'><span className='font-bold dark:text-primary-dark'>Found: </span>{reconData?.length > 0 ? reconData?.length - 1 : 0} Business Days for {moment(month)?.format('MMM')}</p>
                                </div>
                            </div>
                            <div className='my-3'>
                                <BankReconTable
                                    rows={reconData}
                                    type={item}
                                    loading={loadingRows}
                                    searchQuery={search}
                                    showOnlyNonZeroVar={activeTab?.value === 'variance'}
                                />
                            </div>
                        </div>
                    })}

                </div>
                <div className='my-3 flex flex-col md:flex-row md:justify-end'>
                    <Button
                        label={'Download .xlxs'}
                        className='btn-primary-rounded-less !bg-white !shadow-none !text-[#171717] border !border-1 !border-[#171717] mr-0 md:mr-3'
                        onClickButton={() => exportBankReconExcel(reconData, month)}
                    />
                    <Button
                        label={'Close'}
                        className='btn-primary-rounded-less dark:bg-black'
                        onClickButton={onClose}
                    />
                </div>
            </div>
        </Modal>
    );
};

export default BankReconModal;
